import { IFormViewForm } from 'components/FormView';

const DiaryDetails: IFormViewForm = {
  id: 'DiaryDetails',
  layout: {
    rows: 1,
    columns: 1
  },
  fields: [
    {
      id: '1',
      type: 'PAPER_CONTAINER',
      props: {
        fullWidth: true
      },
      position: {
        row: 1,
        col: 1,
        colspan: 3
      },
      visible: true,
      children: [
        {
          id: '1',
          type: 'DIARY_DETAILS',
          props: {
            label: 'SupplierInvoiceDiary',
            name: 'DiaryDetails',
            createApi: '/SupplierInvoiceEnquiry/SupplierInvoice/Diary/Invoices/<DocumentNumber>/CreateDiary',
            updateApi: '/SupplierInvoiceEnquiry/SupplierInvoice/Invoices/<DocumentNumber>/Diary/<DiaryId>',
            searchByIdApi: '/SupplierInvoiceEnquiry/SupplierInvoice/Invoices/<DocumentNumber>/Diary/<DiaryId>',
            deleteApi: '/SupplierInvoiceEnquiry/SupplierInvoice/Invoices/<DocumentNumber>/Diary/<DiaryId>'
          }
        }
      ]
    }
  ]
};
export default DiaryDetails;
